import '../css/swiper.less';
import Swiper from 'swiper/js/swiper';
import $ from "jquery";

class Slider {

	Init = () => {

		let count_el = $('.gallery .swiper-slide:last-child').index();
		if(count_el>0){
			$('.gallery .swiper-pagination').show();
			$('.gallery .swiper-button-next, .gallery .swiper-button-prev').addClass('show')
		}
		let gallery = new Swiper ('.gallery .swiper-container', {
			slidesPerView: 1,
			spaceBetween: 0,
            lazy: true,
			speed: 500,
			loop: false,
			threshold: 20,
			allowTouchMove: false,
			navigation: {
				nextEl: '.gallery .swiper-button-next',
				prevEl: '.gallery .swiper-button-prev',
			},
			pagination: {
				el: '.gallery .swiper-pagination',
				clickable: true,
			},
			on: {
				init: function () {

				},
				setTransition: function (swiper, transition) {
					if($(".gallery .swiper-slide-active video").length){
						let video = $(".gallery .swiper-slide-active video").get(0);
						video.pause();
						setTimeout(function() {
							if (!video.playing) {
								video.pause();
							}
						}, 0);
					}
				},
			},

			breakpoints: {
				0: {
					allowTouchMove: true,
				},
				1000: {
					allowTouchMove: false,
				},

			}
		});


		function show_all_flow_slider() {
			if($(window).width()<=1000){

				if($('.roses-block').length && !$('.roses-block-mob').length){
					var html = '<div class="roses-block-mob">\n' +
						'            <div class="swiper-container">\n' +
						'                <div class="swiper-wrapper">';

					$('.roses-block').each(function () {
						$(this).find('.roses-block__item').each(function () {
							html += '<div class="swiper-slide"><div class="roses-block__item">'+$(this).html()+'</div></div>';
						});
					});

					html += '</div>\n' +
						'            </div>\n' +
						'            <div class="swiper-pagination"></div>\n' +
						'        </div>';
					$('.roses-block').eq(0).before(html);


					let r_count_el = $('.roses-block-mob .swiper-slide:last-child').index();
					if(r_count_el>0){
						$('.roses-block-mob .swiper-pagination').show();
					}
					let roses = new Swiper ('.roses-block-mob .swiper-container', {
						slidesPerView: 2,
						spaceBetween: 0,
						lazy: true,
						speed: 500,
						loop: false,
						allowTouchMove: true,
						pagination: {
							el: '.roses-block-mob .swiper-pagination',
							clickable: true,
						},
						breakpoints: {
							0: {
								slidesPerView: 1,
							},
							750: {
								slidesPerView: 2,
							},
						}
					});

				}
			}else{
				$('.roses-block-mob').remove();
			}
		}

		let costumers = '';
		function show_costumers_mob() {
			if($(window).width()<=1000){


				if($('.costumers__items').length){
					$('.costumers__items *').attr('style','');
					$('.costumers__items .swiper-pagination').html('');

					$('.costumers__items').each(function () {
						let count_el = $(this).find('.swiper-slide:last-child').index();
						if(count_el>0){
							$(this).find('.swiper-pagination').show();
						}

						costumers = new Swiper ($(this).find('.swiper-container'), {
							slidesPerView: '3',
							//centeredSlides: true,
							spaceBetween: 50,
							lazy: true,
							speed: 500,
							loop: false,
							allowTouchMove: true,
							pagination: {
								el: $(this).find('.swiper-pagination'),
								clickable: true,
							},

							breakpoints: {
								0: {
									slidesPerView: '1',
									spaceBetween: 0,
									centeredSlides: true,
									loop: true,

								},
								630: {
									slidesPerView: '3',
								},
								1000: {
									slidesPerView: '4',
								},
							}
						});

					});


				}
			}else{
				if(typeof $('.costumers__items').destroy !='undefined'){
					$('.costumers__items').destroy(true, true);
				}
				$('.costumers__items .swiper-pagination').hide();
				$('.costumers__items *').attr('style','');
			}
		}

		show_all_flow_slider();
		show_costumers_mob();

		$(window).resize(function() {
			show_all_flow_slider();
			show_costumers_mob();
		});





	};

}

export default new Slider;